/**
 * @file 落地页触发登录后的全局loading
 * @refs freya main-loading
 */
import './index.styl'
import useI18n from '@/i18n/landing'
import { I18n } from '@/i18n/I18n'
import $ from 'zepto'
import { preventDefault } from '@/utils/dom'

const template = ($i18n: I18n) => {
  return `
<div class="main-loading">
    <div class="slogan">
    <div class="slogan-title">
        ${$i18n.$t('financial.loan.freya.brand.name')}
    </div>
    <div class="slogan-list">
        <div class="slogan-list_item">
            <span class="slogan-list_item_text">
                ${$i18n.$t(
                  'financial.loan.freya.home.brand.desc2'
                )}
            </span>
        </div>
        <div class="slogan-list_item">
            <span class="slogan-list_item_text">${$i18n.$t(
              'financial.loan.freya.home.brand.desc4'
            )}</span>
        </div>
        <div class="slogan-list_item">
            <span class="slogan-list_item_text">${$i18n.$t(
              'financial.loan.freya.home.brand.desc5'
            )}</span>
        </div>
    </div>
    </div>
    <div class="main_loading_bar">
        <div class="main_loading_bar_running">
            <div class="main_loading_bar_running_round"></div>
        </div>
    </div>
</div>`
}
const i18n = useI18n()
const _template = template(i18n)
const $el = $(_template)
const $body = $('body')

export default {
  show() {
    window.scrollTo(0, 0)
    $body.css({
      overflow: 'hidden',
      height: '100vh',
    })
    if (window.document.querySelector('.main-loading')) {
      return $el.show()
    }
    $body.append($el)
    $el.on('touchstart', preventDefault)
  },
  hide() {
    setTimeout(() => {
      $body.css({
        overflow: '',
        height: '',
      })
      $el.hide()
    }, 0)
  },
  destroy() {
    $el.off('touchstart', preventDefault)
    $el.remove()
  },
}
